import { render } from "./PartPriceGuide.vue?vue&type=template&id=0c46e522"
import script from "./PartPriceGuide.vue?vue&type=script&lang=js"
export * from "./PartPriceGuide.vue?vue&type=script&lang=js"

import "./PartPriceGuide.vue?vue&type=style&index=0&id=0c46e522&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__